
import api from '@/api'
import { _types } from './constant'

const state = {
};

const getters = {
};

const actions = {
};

const mutations = {
};
export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};